import { render, staticRenderFns } from "./magazine-article.vue?vue&type=template&id=08a9d5ed&"
import script from "./magazine-article.vue?vue&type=script&lang=js&"
export * from "./magazine-article.vue?vue&type=script&lang=js&"
import style0 from "./magazine-article.vue?vue&type=style&index=0&id=08a9d5ed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports